/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'anagraficaUtenteStatus',
})
export class AnagraficaUtenteStatusPipe implements PipeTransform {

    transform(value: number) {
        if (value === 1) { return 'In approvazione'; }
        if (value === 2) { return 'Approvato'; }
        if (value === 3) { return 'Rifiutato'; }
        return '';
    }

}
